/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: "change-password-form",
  formField: {
    password: {
      name: "password",
      label: "new password",
      type: "password",
      placeholder: "New Password",
      errorMsg: "Password is required.",
      invalidMsg: "Your password should be more than 6 characters.",
    },
    repeatPassword: {
      name: "repeatPassword",
      label: "confirm new password",
      type: "password",
      placeholder: "Confirm New Password",
      errorMsg: "Password Confirmation is required.",
      invalidMsg: "Your password doesn't match.",
    },
  },
};

export default form;
